import { render } from "./CustomerStoriesSection.vue?vue&type=template&id=4b73d492&scoped=true"
import script from "./CustomerStoriesSection.vue?vue&type=script&lang=js"
export * from "./CustomerStoriesSection.vue?vue&type=script&lang=js"

import "./CustomerStoriesSection.vue?vue&type=style&index=0&id=4b73d492&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b73d492"]])

export default __exports__